import { render } from "./LPCarsoul.vue?vue&type=template&id=8fde929e"
import script from "./LPCarsoul.vue?vue&type=script&lang=js"
export * from "./LPCarsoul.vue?vue&type=script&lang=js"

import "./LPCarsoul.vue?vue&type=style&index=0&id=8fde929e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__